import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  fetchChecklistNotifications,
  markMyTaskRead,
  markTaskNotesRead,
  markTaskRead,
  markTaskSeen,
  setPendingNotesTaskId,
} from '../../../checklist/store/checklistSlice';

const STEP_LABELS = { 1: 'Krok 1', 2: 'Krok 2', 3: 'Krok 3' };

const formatDate = (dateStr) => {
  const d = new Date(dateStr);
  const now = new Date();
  const diffMs = now - d;
  const diffMin = Math.floor(diffMs / 60000);
  const diffH = Math.floor(diffMs / 3600000);
  const diffD = Math.floor(diffMs / 86400000);

  if (diffMin < 1) return 'Teraz';
  if (diffMin < 60) return `${diffMin} min temu`;
  if (diffH < 24) return `${diffH} godz. temu`;
  if (diffD < 7) return `${diffD} dni temu`;
  return d.toLocaleDateString('pl-PL', { day: 'numeric', month: 'short' });
};

const NotificationDropdown = ({ userRole, onClose }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const ref = useRef(null);
  const notifications = useSelector(({ checklist }) => checklist.notifications);

  useEffect(() => {
    dispatch(fetchChecklistNotifications());
  }, [dispatch]);

  // Close when clicking outside
  useEffect(() => {
    const handleMouseDown = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        onClose();
      }
    };
    document.addEventListener('mousedown', handleMouseDown);
    return () => document.removeEventListener('mousedown', handleMouseDown);
  }, [onClose]);

  const handleNotificationClick = (n) => {
    if (userRole === 'player') {
      dispatch(markMyTaskRead(n.taskId));
      history.push(`/player/checklist?task=${n.taskId}`);
    } else if (n.type === 'new_task') {
      dispatch(markTaskSeen(n.taskId));
      if (n.playerId) {
        history.push(`/available-players/${n.playerId}?task=${n.taskId}`);
      } else {
        history.push('/admin/assistants');
      }
    } else if (n.type === 'internal_note') {
      dispatch(markTaskNotesRead(n.playerId, n.taskId));
      dispatch(setPendingNotesTaskId(n.taskId));
      const basePath = userRole === 'assistant' ? `/admin/my-players/${n.playerId}` : `/available-players/${n.playerId}`;
      history.push(`${basePath}?tab=checklist`);
    } else {
      dispatch(markTaskRead(n.playerId, n.taskId));
      history.push(`/available-players/${n.playerId}?task=${n.taskId}`);
    }
    onClose();
  };

  return (
    <div ref={ref} className="notif-dropdown">
      <div className="notif-dropdown__header">
        <span>
          <i className="fas fa-bell" style={{ marginRight: '7px', color: '#2e496b' }} />
          Powiadomienia
        </span>
        {notifications.length > 0 && (
          <span className="notif-dropdown__count">{notifications.length}</span>
        )}
      </div>

      {notifications.length === 0 ? (
        <div className="notif-dropdown__empty">
          <i className="fas fa-check-circle" style={{ fontSize: '24px', color: '#22c55e', marginBottom: '8px' }} />
          <div>Brak nowych powiadomień</div>
        </div>
      ) : (
        <div className="notif-dropdown__list">
          {notifications.map((n, i) => (
            <button
              // eslint-disable-next-line react/no-array-index-key
              key={`${n.taskId}-${i}`}
              type="button"
              className="notif-dropdown__item"
              onClick={() => handleNotificationClick(n)}
            >
              <div className="notif-dropdown__item-top">
                <span className="notif-dropdown__item-author">
                  {n.type === 'new_task' ? (
                    <><i className="fas fa-plus-circle" style={{ marginRight: '5px', color: '#22c55e' }} />Nowe zadanie</>
                  ) : n.type === 'internal_note' ? (
                    <><i className="fas fa-sticky-note" style={{ marginRight: '5px', color: '#d97706' }} />{n.author}</>
                  ) : (
                    <><i className="fas fa-comment-dots" style={{ marginRight: '5px' }} />{n.author}</>
                  )}
                </span>
                <span className="notif-dropdown__item-date">{formatDate(n.createdAt)}</span>
              </div>
              <div className="notif-dropdown__item-task">
                <span className="notif-dropdown__item-step">{STEP_LABELS[n.step]}</span>
                {n.taskLabel}
              </div>
              {n.preview && n.type !== 'new_task' && (
                <div className="notif-dropdown__item-preview">
                  &ldquo;{n.preview}&rdquo;
                </div>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default NotificationDropdown;
